import { FC } from 'react';
import { Descriptions } from 'antd';
import { DescriptionsItemProps } from 'antd/lib/descriptions/Item';

const DescriptionsAtomItem: FC<DescriptionsItemProps> = ({ children, ...props }) => {
  return <Descriptions.Item {...props}>{children}</Descriptions.Item>;
};

export default DescriptionsAtomItem;
